import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { toast } from "./use-toast";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ADMIN_SESSION_CONFIG = { withCredentials: true };

export const useAdminSession = () => {
  const [authenticated, setAuthenticated] = useState(null);
  const [checkingSession, setCheckingSession] = useState(true);
  const [authLoading, setAuthLoading] = useState(false);

  const checkSession = useCallback(async () => {
    setCheckingSession(true);
    try {
      await axios.get(`${API}/admin/session`, ADMIN_SESSION_CONFIG);
      setAuthenticated(true);
    } catch {
      setAuthenticated(false);
    } finally {
      setCheckingSession(false);
    }
  }, []);

  useEffect(() => {
    checkSession();
  }, [checkSession]);

  const signIn = useCallback(async (token) => {
    if (!token.trim()) return false;
    setAuthLoading(true);
    try {
      await axios.post(`${API}/admin/session`, { token: token.trim() }, ADMIN_SESSION_CONFIG);
      setAuthenticated(true);
      toast({ title: "Signed in" });
      return true;
    } catch {
      toast({ title: "Invalid token", description: "The admin token you entered is incorrect." });
      setAuthenticated(false);
      return false;
    } finally {
      setAuthLoading(false);
    }
  }, []);

  const signOut = useCallback(async () => {
    try {
      await axios.delete(`${API}/admin/session`, ADMIN_SESSION_CONFIG);
    } catch {
      // Ignore logout network issues and clear local auth state anyway.
    } finally {
      setAuthenticated(false);
    }
  }, []);

  return {
    authenticated,
    checkingSession,
    authLoading,
    signIn,
    signOut,
    adminSessionConfig: ADMIN_SESSION_CONFIG,
  };
};